import React from 'react';
import { TileLayer } from 'react-leaflet';

// OSM requires identifiable browser requests. Origin-only referrers disclose
// neither page paths nor query/fragment secrets; never proxy or cache-bust tiles.
export const OpenStreetMapTiles = ({ mapId }) => (
  <TileLayer
    url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
    referrerPolicy="origin"
    attribution={`&copy; <a href="https://www.openstreetmap.org/copyright" data-testid="${mapId}-osm-attribution">OpenStreetMap</a> contributors`}
  />
);